export enum Operator {
    AND = 'AND',
    OR = 'OR'
}

export type OperatorType = keyof typeof Operator;
